/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LinearOrder = {
    type: LinearOrder.type;
    minId: number;
};
export namespace LinearOrder {
    export enum type {
        LINEAR = 'linear',
    }
}

